import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getDatabase, ref, get } from "firebase/database";
import { useNavigate } from "react-router-dom";

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";
import EmptyData from "components/EmptyData";
import { ToastContainer } from "react-toastify";

import { useMaterialUIController } from "context";
// import { getCurrentAdminState } from "Utils/Functions";
import NotificationImage from "Utils/NotificationImage";
import { formatDate } from "Utils/helper";

function NotificationPage() {
  const navigate = useNavigate();
  const [controller] = useMaterialUIController();
  const { loggedIn } = controller;
  const allData = useSelector((state) => state.data.allData);
  const getUserState = useSelector((state) => state?.data?.getUserState);

  const [rows, setRows] = useState([]);
  const [searchTxt, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);

  const columns = [
    {
      Header: <span style={{ color: "blue" }}>Sr</span>,
      accessor: "Sr",
      width: "5%",
      align: "left",
    },

    {
      Header: <span style={{ color: "blue" }}>Title</span>,
      accessor: "Title",
      width: "10%",
      align: "left",
    },
    {
      Header: <span style={{ color: "blue" }}>Text</span>,
      accessor: "Text",
      width: "70%",
      align: "left",
    },
    {
      Header: <span style={{ color: "blue" }}>State</span>,
      accessor: "State",
      width: "70%",
      align: "left",
    },
    {
      Header: <span style={{ color: "blue" }}>Time</span>,
      accessor: "Time",
      width: "5%",
      align: "left",
    },
  ];

  const getData = async () => {
    setLoading(true);
    const db = getDatabase();
    const notifRef = ref(db, "/notification");

    try {
      const { superAdmin, state: userState } = JSON.parse(localStorage.getItem("user")) || {};
      const selectedState = getUserState || "All State";

      const snapShot = await get(notifRef);
      if (snapShot.exists()) {
        const data = snapShot.val();
        //console.log("Notification data", data);

        const filteredData = Object.entries(data).filter(([key, value]) => {
          if (superAdmin) {
            if (selectedState === "All State") return true;
            return value.state === selectedState;
          } else {
            return value.state === userState;
          }
        });

        const sortedData = filteredData.sort(
          ([, a], [, b]) =>
            new Date(b.currentTimeStamp).getTime() - new Date(a.currentTimeStamp).getTime()
        );

        //console.log("sortedData", sortedData);

        const formattedRows = sortedData.map(([key, value], idx) => ({
          Sr: idx + 1,
          TitleText: value?.title || "",
          Title: (
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <NotificationImage title={value?.title} width={25} height={25} />
              <span>{value.title}</span>
            </div>
          ),
          Text: value?.text || "",
          State: value?.state || "",
          Time: formatDate(value?.currentTimeStamp) || "-",
        }));

        setRows(formattedRows);
      } else {
        setRows([]);
      }
    } catch (error) {
      // console.error("Error fetching notification data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (!user) navigate("/authentication/sign-in");
    getData();
  }, [allData, getUserState]);

  useEffect(() => {
    if (searchTxt.trim() === "") {
      getData();
    } else {
      setRows((prevRows) =>
        prevRows.filter(
          (row) =>
            row?.Text?.toLowerCase().includes(searchTxt.toLowerCase()) ||
            row?.TitleText?.toLowerCase().includes(searchTxt.toLowerCase())
        )
      );
    }
  }, [searchTxt]);

  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar value={searchTxt} onChange={handleSearchChange} />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6} style={{ position: "relative", minHeight: "60vh" }}>
          {loading ? (
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }}
            >
              Loading...
            </div>
          ) : (
            <Grid item xs={12}>
              <Card>
                <MDBox
                  mx={2}
                  mt={-3}
                  py={3}
                  px={2}
                  variant="gradient"
                  bgColor="info"
                  borderRadius="lg"
                  coloredShadow="info"
                >
                  <ToastContainer />
                  <MDTypography variant="h6" color="white">
                    Notification
                  </MDTypography>
                </MDBox>

                <MDBox pt={3}>
                  {rows.length > 0 ? (
                    <DataTable
                      table={{ columns, rows }}
                      isSorted={false}
                      entriesPerPage={false}
                      showTotalEntries={false}
                      noEndBorder
                    />
                  ) : (
                    <EmptyData />
                  )}
                </MDBox>
              </Card>
            </Grid>
          )}
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default NotificationPage;
